import React from 'react'
import nyaDaily30Image from '../../images/news/NYA_DAILY30.webp'

const Daily30 = ({ waiting }) => <img className={`playlist-image ${waiting}`} src={nyaDaily30Image} loading='lazy'/>
export default Daily30;
